// Petpooja restaurant_id → canonical outlet id + display name + city.
// Mirrors PETPOOJA_OUTLETS in the flax-outlets repo (shared/lib/outlet-map.ts);
// keep the two in sync. The POS DSR views (petpooja_dsr_daily, flax_pos_item_daily)
// are keyed by Petpooja restaurant_id, so this map is how we surface readable
// outlet + city labels in the Business Review — including Goa, which lives only
// in the Petpooja feed today.

export interface PetpoojaOutlet {
  id: string;
  name: string;
  city: string;
}

export const PETPOOJA_OUTLETS: Record<string, PetpoojaOutlet> = {
  '86112': { id: 'andheri_west', name: 'Andheri West', city: 'Mumbai' },
  '430772': { id: 'andheri_east', name: 'Andheri East / Marol', city: 'Mumbai' },
  '67411': { id: 'bandra_khar', name: 'Bandra / Khar', city: 'Mumbai' },
  '68713': { id: 'breach_candy', name: 'Breach Candy', city: 'Mumbai' },
  '330910': { id: 'fort', name: 'Fort / Kalaghoda', city: 'Mumbai' },
  '364954': { id: 'santacruz_kalina', name: 'Santacruz / Kalina', city: 'Mumbai' },
  '67409': { id: 'lower_parel', name: 'Lower Parel', city: 'Mumbai' },
  '321235': { id: 'malad', name: 'Malad', city: 'Mumbai' },
  '61343': { id: 'powai', name: 'Powai', city: 'Mumbai' },
  '374829': { id: 'indiranagar', name: 'Indiranagar', city: 'Bangalore' },
  '446886': { id: 'goa', name: 'Goa', city: 'Goa' },
};

/** Resolve a Petpooja restaurant_id → { id, name, city }, falling back to the raw id. */
export function petpoojaOutlet(restaurantId: string): PetpoojaOutlet {
  return (
    PETPOOJA_OUTLETS[restaurantId] ?? { id: restaurantId, name: restaurantId, city: 'Other' }
  );
}
